const Alerts = {
    SUCCESS: "success",
    ERROR: "error",
}

export default Alerts;